import SkeletonBase from './SkeletonBase';

const SkeletonText = ({
  lines = 1,
  widths = [],
  lineHeight = '1em',
  gap = '0.5rem',
  className = '',
  style = {},
  variant,
  ...props
}) => {
  const defaultWidths = ['100%', '80%', '90%', '70%', '85%'];

  const getWidth = (index) => {
    if (widths[index]) return widths[index];
    return defaultWidths[index % defaultWidths.length];
  };

  if (lines === 1) {
    return (
      <SkeletonBase
        width={widths[0] || '100%'}
        height={lineHeight}
        borderRadius="var(--radius-sm)"
        className={`skeleton-text ${className}`}
        style={style}
        variant={variant}
        {...props}
      />
    );
  }

  return (
    <div
      className={className}
      style={{ display: 'flex', flexDirection: 'column', gap, ...style }}
      aria-hidden="true"
      {...props}
    >
      {Array.from({ length: lines }).map((_, index) => (
        <SkeletonBase
          key={index}
          width={getWidth(index)}
          height={lineHeight}
          borderRadius="var(--radius-sm)"
          className="skeleton-text skeleton-text-line"
          variant={variant}
        />
      ))}
    </div>
  );
};

export default SkeletonText;
